import { API_TYPE } from "../../utils/config";

export const MUTATION_AGENT_SIGNUP = API_TYPE("MUTATION_AGENT_SIGNUP");
export const ADD_NEWSLETTER_MAILING_LIST = API_TYPE("ADD_NEWSLETTER_MAILING_LIST");
export const ADD_CONTACT_US_INFO_LIST=API_TYPE("ADD_CONTACT_US_INFO_LIST");
